import Debug from '@/util/debug';
import { required, email } from 'vuelidate/lib/validators';
import FormInput from '@/components/form-input/FormInput.vue';
import 'vue-awesome/icons/copy';
import 'vue-awesome/icons/check';

const debug = Debug('send-email');

export default {
  dependencies: ['draftService', 'packageService'],
  components: {
    'form-input': FormInput,
  },
  props: {
    campaign: Object,
    send_campaign_summary: null,
  },
  data() {
    return {
      loading: true,
      package: null,
      error: false,
      success: false,
      email: null,
      canEmail: true,
      copySuccess: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    sendEmail() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else if (this.canEmail) {
        this.canEmail = false;
        const campaignId = this.$route.params.id;
        this.draftService.sendEmail(campaignId, this.email)
          .then(() => {
            this.email = null;
            this.$v.email.$reset();
            this.success = true;
            this.canEmail = true;
          })
          .catch(err => {
            debug.warn('error while sending email: %o', err);
            this.error = err;
            this.canEmail = true;
          });
      }
    },
    goToProposal(id) {
      this.$router.push({
        name: 'proposal',
        params: {
          id,
        },
      });
    },
    copyCampaignCode() {
      this.$copyText(this.campaign.famCampaign.code)
        .then(() => {
          this.copySuccess = true;
          setTimeout(() => {
            this.copySuccess = false;
          }, 1000);
        })
        .catch(e => debug.warn(e));
    },
  },
  mounted() {
    const fin = (err = null) => {
      debug.info('finished loading. error: %o', err);
      this.loading = false;
    };

    this.packageService.getCampaignPackage(this.campaign, true)
      .then(p => this.package = p)
      .then(fin)
      .catch(fin);
  },
};



// WEBPACK FOOTER //
// ./src/components/send-email/SendEmail.js